import { ItemBidFormData  } from "components/Form/ItemBidForm/ItemBidForm";
import { ItemBidAdditionalDataFormData } from "components/Form/ItemBidAdditionalDataForm/ItemBidAdditionalDataForm";
import { ItemBidModel } from "models";
import { JSONObject } from "models/Api/types";

export function getBidEditPayload(
  original: ItemBidModel,
  currentForm: ItemBidFormData,
  currentAdditional: ItemBidAdditionalDataFormData): JSONObject {
  const dirty: JSONObject = {};

  if (currentForm.bidPrice && currentForm.bidPrice !== original.amount) {
    dirty.amount = currentForm.bidPrice;
  }

  if (currentForm.bidExpiration && currentForm.bidExpiration !== original.expirationDays) {
    dirty.expiration_days = currentForm.bidExpiration;
  }

  if (currentAdditional.condition && currentAdditional.condition !== original.condition) {
    dirty.condition = currentAdditional.condition;
  }

  if (currentAdditional.notes && currentAdditional.notes !== original.notes) {
    dirty.notes = currentAdditional.notes;
  }

  if (currentAdditional.address && !currentAdditional.address.isEqual(original.address)) {
    dirty.address = currentAdditional.address.toObject();
  }

  if (currentAdditional.useEscrow !== original.useEscrow) {
    dirty.use_escrow = !!currentAdditional.useEscrow;
  }

  return dirty;
}